export default "__VITE_ASSET__BK_AOj5C__"